import { useState, useEffect } from 'react';
import {
  Layout,
  Breadcrumb,
  Typography,
  Upload,
  Form,
  Input,
  Button,
  Table,
  Space,
  Modal,
  Popconfirm,
  message,
  Avatar,
  Tooltip
} from 'antd';
import {
  LoadingOutlined,
  UploadOutlined,
  QuestionCircleOutlined,
  CopyOutlined
} from '@ant-design/icons';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import api from '../../service/api';
import * as S from './styles';
import { UserOutlined, FileOutlined } from '@ant-design/icons';
import ReprocessarEqualsModal from './ReprocessarEqualsModal';
import ExtratosPainelResumo from './ExtratosPainelResumo';
const { Title } = Typography;
const { Content } = Layout;
const { Search } = Input;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};


const TablePage = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory();

  const [isSpinning, setIsSpinning] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [isIframeModalVisible, setIsIframeModalVisible] = useState(false);
  const [isReprocessarEqualsModalVisible, setIsReprocessarEqualsModalVisible] = useState(false);

  // Busca todos os clientes
  const fetchClients = async () => {
    setIsLoading(true);
    try {
      const endpoint = searchTerm
        ? `/api/Cliente/filter?filter=${searchTerm}`
        : '/api/Cliente';

      const response = await api.get(endpoint);
      setClients(response.data);
    } catch (error) {
      toast.error('Erro ao carregar clientes');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, [searchTerm]);

  // Cria um novo cliente
  const handleCreateClient = async (values) => {
    setIsLoading(true);
    const formData = new FormData();

    formData.append('Email', values.email);
    formData.append('Password', values.password);
    formData.append('PowerBi', values.powerBi);
    formData.append('Conciliador', values.conciliador);
    formData.append('NomeDoGrupo', values.nomeDoGrupo);

    if (selectedFile) {
      try {
        const arrayBuffer = await selectedFile.arrayBuffer();
        const base64String = arrayBufferToBase64(arrayBuffer);
        formData.append('Img', base64String);
      } catch (error) {
        console.error('Erro ao converter imagem:', error);
      }
    }

    try {
      await api.post('/api/Cliente', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Cliente criado com sucesso');
      fetchClients();
    } catch (error) {
      toast.error('Erro ao criar cliente');
    } finally {
      setIsLoading(false);
    }
  };

  // Deleta um cliente
  const handleDeleteClient = async (id) => {
    setIsLoading(true);
    try {
      await api.delete(`/api/Cliente/${id}`);
      message.success('Cliente deletado com sucesso');
      fetchClients();
    } catch (error) {
      toast.error('Erro ao deletar cliente');
    } finally {
      setIsLoading(false);
    }
  };

  // Redireciona para a página do cliente
  const handleAccessClient = (id) => {
    const win = window.open(`/acessar/${id}`, "_blank");
    if (win) {
      win.focus();
    }
  };

  // Utilitário para converter imagem para base64
  const arrayBufferToBase64 = (buffer) => {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    bytes.forEach(byte => binary += String.fromCharCode(byte));
    return window.btoa(binary);
  };

  // Configurações da tabela
  const columns = [
    {
      title: 'Logo',
      dataIndex: 'img',
      key: 'img',
      width: 150,
      render: (img) => (
        <img
          style={{ width: '100px' }}
          src={`data:image/png;base64,${img}`}
          alt="logo cliente"
        />
      )
    },
    {
      title: 'Nome do Grupo',
      dataIndex: 'nomeDoGrupo',
      key: 'nomeDoGrupo',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 300,
    },
    {
      title: 'Senha',
      dataIndex: 'password',
      key: 'password',
      width: 150,
      render: (password) => (
        <Space>
          <span>{password}</span>
          <Tooltip title="Copiar senha">
            <Button
              type="text" // Remove fundo e borda
              icon={<CopyOutlined style={{ color: '#B0B0B0', fontSize: 16 }} />}
              size="small"
              onClick={() => {
                navigator.clipboard.writeText(password);
                message.success('Senha copiada!');
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 250,
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => handleAccessClient(record.id)}
          >
            Acessar
          </Button>
          <Popconfirm
            title="Deseja deletar este cliente?"
            content="Esta ação não pode ser desfeita"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => handleDeleteClient(record.id)}
          >
            <Button type="primary" danger>
              Deletar
            </Button>
          </Popconfirm>
        </Space>
      )
    },
  ];

  const antIcon = <LoadingOutlined style={{ fontSize: 34, color: '#2ce414' }} spin />;

  async function onFinish(values) {
    const formData = new FormData();
    formData.append('Email', values.email);
    formData.append('Password', values.password);
    formData.append('PowerBi', values.powerBi);
    formData.append('Conciliador', values.conciliador);
    formData.append('NomeDoGrupo', values.nomeDoGrupo);

    if (selectedFile) {
      try {
        const arrayBuffer = await selectedFile.arrayBuffer();
        const base64String = arrayBufferToBase64(arrayBuffer);
        formData.append('Img', base64String);
      } catch (error) {
        console.error('Erro ao converter o arquivo para array de bytes:', error);
      }
    }

    setIsSpinning(true);

    try {
      await api.post(`/api/Cliente`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('Cliente criado com sucesso');
      await fetchClients();
      setIsModalVisible(false);
      window.location.reload();
    } catch (error) {
      toast.error('Um erro inesperado aconteceu');
    } finally {
      setIsSpinning(false);
    }
  }

  const handleUpload = (options) => {
    const { file, onSuccess, onError } = options;

    setSelectedFile(file);

    const formData = new FormData();
    formData.append('file', file);

    api.post('/api/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        onSuccess?.({}, file);
      })
      .catch((error) => {
        onError?.(error);
      });

    return false;
  };

  return (
    <Layout className="layout">
        <Content style={{
          backgroundColor: 'white',
          padding: '10px 50px 50px 50px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <S.ContainerTitle style={{ display: 'flex', justifyContent: 'space-between', margin: 'auto' }}>
            <Title level={3} style={{ fontSize: "35px", fontWeight: "bold" }}>Clientes Assessoria Cartões</Title>
          </S.ContainerTitle>
          {/* Seção de listagem */}
          <S.SiteLayoutContent>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>

              <div style={{ display: 'flex', gap: '10px' }}>
                <Search
                  placeholder="Pesquisar clientes..."
                  allowClear
                  enterButton
                  onSearch={setSearchTerm}
                  style={{ width: 400 }}
                />
                <Button type="primary" onClick={() => setIsModalVisible(true)}>
                  Cadastrar novo cliente
                </Button>
                <Button
                  type="primary"
                  style={{ backgroundColor: '#fa8c16', borderColor: '#fa8c16' }}
                  onClick={() => setIsReprocessarEqualsModalVisible(true)}
                >
                  Reprocessar Equals
                </Button>
              </div>

              <div style={{ display: 'flex', gap: '10px' }}>
                <Button type="primary" onClick={() => setIsIframeModalVisible(true)}>
                  Extratos no Painel
                </Button>
              </div>
            </div>

            <Table
              columns={columns}
              dataSource={clients}
              rowKey="id"
              pagination={{ pageSize: 30 }}
              scroll={{ y: 700 }}
              loading={{ spinning: isLoading, indicator: antIcon }}
            />

            <Modal
              title={<span style={{ fontSize: '24px' }}>Cadastrar novo cliente</span>}
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={null}
              width={1200}
            >

              <Form name="nest-messages" onFinish={onFinish}>
                <Form.Item
                  name="nomeDoGrupo"
                  label="Nome do Grupo"
                  rules={[{ required: true, message: 'Por favor insira o Nome Do Grupo' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="email"
                  label="E-mail"
                  rules={[{ required: true, message: 'Por favor insira o E-mail' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Senha"
                  rules={[{ required: true, message: 'Por favor insira a senha' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="powerBi"
                  label="Power BI"
                  rules={[{ required: true, message: 'Por favor insira o Power Bi' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="conciliador"
                  label="Link Conciliador"
                  rules={[{ required: true, message: 'Por favor insira o Link Do Conciliador' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="clientImage"
                  label="Imagem Cliente"
                  rules={[{ required: true, message: 'Por favor insira uma imagem' }]}
                >
                  <Upload
                    listType="picture"
                    customRequest={handleUpload}
                    accept=".png, .jpeg, .jpg"
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Salvar
                  </Button>
                </Form.Item>
              </Form>
            </Modal>

            {/* <RelatorioAgrupadoModal
                  isIframeModalVisible={isIframeModalVisible}
                  setIsIframeModalVisible={setIsIframeModalVisible}
              /> */}
            <Modal
              title=""
              visible={isIframeModalVisible}
              onCancel={() => setIsIframeModalVisible(false)}
              footer={null}
              width="90%" // largura do modal
              destroyOnClose
            >
              {isIframeModalVisible && <ExtratosPainelResumo />}
            </Modal>

            <ReprocessarEqualsModal
              isVisible={isReprocessarEqualsModalVisible}
              setIsVisible={setIsReprocessarEqualsModalVisible}
            />

          </S.SiteLayoutContent>
        </Content>
      </Layout>
  );
};

export default TablePage;